import { Component, OnInit } from '@angular/core'
import { LoginService } from '../services/login.service'
import { Router } from '@angular/router'
import { InternalAgent } from './../../content/interfaces/InternalAgent'
import { ToastService } from 'src/app/service/toast/toast.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { IconImageService } from 'src/app/shared/services/icon-image.service'

@Component({
  selector: 'app-agent-list',
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.scss'],
  standalone: false,
})
export class AgentListComponent implements OnInit {
  agents: Array<InternalAgent> = {} as Array<InternalAgent>
  showDelete = false
  deleteAgent: InternalAgent = {} as InternalAgent
  private unsubscribe = new Subject()

  constructor(
    private loginService: LoginService,
    private router: Router,
    private toasterService: ToastService,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.loadAgents()
  }

  loadAgents() {
    this.loginService.getAllAgents().subscribe((res) => (this.agents = res))
  }

  createNew(): void {
    this.router.navigate(['/main/general/createAgent/'])
  }

  formatTimestamp(value: number): string {
    var d = new Date(value)
    const mont = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
    const date = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
    const year = d.getFullYear()
    return mont + ' ' + date + ', ' + year
  }

  formatAccess(context: string) {
    if (context === 'AG.Web.Internal') {
      return 'Full'
    } else if (context === 'AG.Web.Internal.Limited') {
      return 'Limited'
    }
  }

  onDeleteClick(identifier: string) {
    var agent = this.agents.find((x) => x.Identifier === identifier)
    if (agent) {
      this.deleteAgent = agent
      this.showDelete = true
    }
  }

  closeDelete() {
    this.showDelete = false
    this.deleteAgent = null
  }

  confirmDelete() {
    this.loginService
      .deleteAgent(this.deleteAgent.Identifier, this.deleteAgent.Context)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (_) => {
          this.toasterService.success({ message: `User deleted` })
          setTimeout(() => this.loadAgents(), 1000)
          this.closeDelete()
        },
        (_) => this.toasterService.error({ message: `User deletion failed.` }),
      )
  }

  childClick(e: Event) {
    e.stopPropagation()
  }
}
